import { Response } from 'request-dot-js'

export const getNextPageParam = (lastPage: Response<any>, pages: Response<any>[]) => {
  if (lastPage.type === 'exception') return undefined

  const totalPages = Number(lastPage.headers['total-pages'])
  const currentPage = Number(lastPage.headers['current-page'])

  // Validate that we have valid page numbers
  if (isNaN(totalPages) || isNaN(currentPage) || totalPages < 1 || currentPage < 1) {
    return undefined
  }

  const nextPage = currentPage + 1

  if (nextPage <= totalPages) return nextPage

  return undefined
}
